// components/AuthProvider.tsx
'use client'
import { createContext, useContext, useEffect, useState } from 'react'
import { getSupabaseClient } from '@/lib/supabase/client'

type AuthCtx = { user: any | null; ready: boolean }
const Ctx = createContext<AuthCtx>({ user: null, ready: false })

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any | null>(null)
  const [ready, setReady] = useState(false)

 useEffect(() => {
  let mounted = true
  let unsub: (() => void) | undefined

  const init = async () => {
    let sb: any
    try {
      sb = getSupabaseClient()
    } catch (e) {
      console.warn('[AuthProvider] supabase init failed', e)
      if (mounted) setReady(true)
      return
    }

    if (!sb?.auth) {
      console.warn('[AuthProvider] sb.auth missing')
      if (mounted) setReady(true)
      return
    }

    try {
      // ✅ Replace getSession() with getUser()
      const { data } = await sb.auth.getUser()
      if (mounted) setUser(data?.user ?? null)
    } catch (e) {
      console.warn('[AuthProvider] getUser error', e)
    }

    try {
      const { data } = sb.auth.onAuthStateChange((_e: any, sess: any) => {
        if (mounted) setUser(sess?.user ?? null)
      })
      unsub = data?.subscription?.unsubscribe
    } catch (e) {
      console.warn('[AuthProvider] onAuthStateChange error', e)
    }

    if (mounted) setReady(true)
  }

  // start after first tick to ensure env is ready
  const id = setTimeout(init, 0)

  return () => {
    mounted = false
    clearTimeout(id)
    try { unsub?.() } catch {}
  }
}, [])


  return <Ctx.Provider value={{ user, ready }}>{children}</Ctx.Provider>
}
export const useAuth = () => useContext(Ctx)
